 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {commitMutation} from 'react-relay'

import onMeetingRoute from '~/utils/onMeetingRoute'


import {RetroDemo} from '../types/constEnums'








import handleAddTimelineEvent from './handlers/handleAddTimelineEvent'
import handleRemoveSuggestedActions from './handlers/handleRemoveSuggestedActions'
import popEndMeetingToast from './toasts/popEndMeetingToast'

graphql`
  fragment EndRetrospectiveMutation_team on EndRetrospectiveSuccess {
    isKill
    meeting {
      id
      endedAt
      teamId
      commentCount
      reflectionCount
      taskCount
      topicCount
      autogroupReflectionGroups {
        groupTitle
      }
      reflectionGroups(sortBy: voteCount) {
        summary
        reflections {
          id
        }
      }
      transcription {
        speaker
        words
      }
      phases {
        phaseType
        ... on DiscussPhase {
          stages {
            discussion {
              summary
            }
          }
        }
      }
    }
    team {
      id
      activeMeetings {
        id
      }
      insights {
        ...TeamDashInsights_insights
      }
    }
    timelineEvent {
      id
      team {
        id
        name
      }
      type
    }
  }
`

graphql`
  fragment EndRetrospectiveMutation_notification on EndRetrospectiveSuccess {
    removedSuggestedActionId
  }
`

graphql`
  fragment EndRetrospectiveMutation_meeting on EndRetrospectiveSuccess {
    meeting {
      ...WholeMeetingSummary_meeting
      taskCount
    }
  }
`

const mutation = graphql`
  mutation EndRetrospectiveMutation($meetingId: ID!) {
    endRetrospective(meetingId: $meetingId) {
      ... on ErrorPayload {
        error {
          message
        }
      }
      ...EndRetrospectiveMutation_notification @relay(mask: false)
      ...EndRetrospectiveMutation_team @relay(mask: false)
      ...EndRetrospectiveMutation_meeting @relay(mask: false)
    }
  }
`

export const endRetrospectiveTeamOnNext


 = (payload, context) => {
  const {isKill, meeting} = payload
  const {atmosphere, history} = context
  if (!meeting) return
  const {id: meetingId, teamId, reflectionGroups, phases, autogroupReflectionGroups} = meeting
  if (meetingId === RetroDemo.MEETING_ID) {
    if (isKill) {
      window.localStorage.removeItem('retroDemo')
      history.push('/create-account')
    } else {
      history.push('/retrospective-demo-summary')
    }
  } else if (onMeetingRoute(window.location.pathname, [meetingId])) {
    if (isKill) {
      history.push(`/team/${teamId}`)
      popEndMeetingToast(atmosphere, meetingId)
    } else {
      const discussPhase = phases.find((phase) => phase.phaseType === 'discuss')
      const {stages} = _nullishCoalesce(discussPhase, () => ( {}))
      const hasTopicSummary = reflectionGroups.some((group) => group.summary)
      const reflections = reflectionGroups.flatMap((group) => group.reflections) // reflectionCount hasn't been calculated yet so check reflections length
      const hasDiscussionSummary = !!_optionalChain([stages, 'optionalAccess', _ => _.some, 'call', _2 => _2((stage) => _optionalChain([stage, 'access', _3 => _3.discussion, 'optionalAccess', _4 => _4.summary]))])
      const hasOpenAISummary = hasTopicSummary || hasDiscussionSummary
      const hasTeamHealth = phases.some((phase) => phase.phaseType === 'TEAM_HEALTH')
      const pathname = `/new-summary/${meetingId}`
      const search = new URLSearchParams()
      const hasSuggestGroups = !!_optionalChain([autogroupReflectionGroups, 'optionalAccess', _5 => _5.length])
      if (hasSuggestGroups) {
        const suggestGroupsStr = reflections.length > 40 ? 'sg-xl' : 'sg'
        search.append(suggestGroupsStr, 'true')
      }
      if (hasOpenAISummary) {
        search.append('ai', 'true')
      }
      if (hasTeamHealth) {
        search.append('team-health', 'true')
      }
      history.push({
        pathname,
        search: search.toString()
      })
    }
  }
}

export const endRetrospectiveNotificationUpdater

 = (payload, {store}) => {
  const removedSuggestedActionId = payload.getValue('removedSuggestedActionId')
  handleRemoveSuggestedActions(removedSuggestedActionId, store)
}

export const endRetrospectiveTeamUpdater = (
  payload,
  {store}
) => {
  const meeting = payload.getLinkedRecord('meeting') 
  const timelineEvent = payload.getLinkedRecord('timelineEvent') 
  handleAddTimelineEvent(meeting, timelineEvent, store)
}

const EndRetrospectiveMutation


 = (atmosphere, variables, {onError, onCompleted, history}) => {
  return commitMutation(atmosphere, {
    mutation,
    variables,
    updater: (store) => {
      const payload = store.getRootField('endRetrospective')
      if (!payload) return
      const context = {atmosphere, store: store }
      endRetrospectiveNotificationUpdater(payload , context)
      endRetrospectiveTeamUpdater(payload , context)
    },
    onCompleted: (res, errors) => {
      if (onCompleted) {
        onCompleted(res, errors)
      }
      endRetrospectiveTeamOnNext(res.endRetrospective , {atmosphere, history})
    },
    onError
  })
}

export default EndRetrospectiveMutation
